<ng-container *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-actions>
			<button
				*ngIf="vo.canEdit"
				id="{{ cmpId }}'-edit-btn"
				class="app-project-home__edit-btn"
				matTooltip="modify project"
				i18n-matTooltip="@@project.home.edit.btn"
				mat-icon-button
				(click)="navigateToEditRoute()">
				<mat-icon [svgIcon]="DcIcons.Settings"></mat-icon>
			</button>
		</app-page-actions>
		<app-page-content>
			<div class="page-content">
				<div class="app-project-home__metadata">
					<div class="app-project-home__label">{{ vo.metadata.label }}</div>
					<div
						[matTooltip]="vo.metadata.description"
						[matTooltipDisabled]="
							vo.metadata.description.length < descriptionMaxLength
						">
						{{
							vo.metadata.description
								| truncate: descriptionMaxLength:descriptionMaxLines:'end'
						}}
					</div>
				</div>
				<div
					class="element-selection"
					i18n="@@project.home.select-item-message">
					select element
				</div>
				<div class="element-cards">
					<ng-container *ngFor="let item of vo.stat | keyvalue: noSorting">
						<div
							class="element-cards__entry"
							[ngClass]="{
								'generics-selected':
									item.key === vo.selectedElement && vo.module === 'generics',
								'handle-selected':
									item.key === vo.selectedElement && vo.module === 'handle'
							}">
							<div
								class="element-card"
								(click)="changeElementSelection(item.key)">
								<div class="element-card__type">
									<ng-container
										[ngTemplateOutlet]="elementIcon"
										[ngTemplateOutletContext]="{
											$implicit: item.key
										}"></ng-container>
									<ng-container
										[ngTemplateOutlet]="elementType"
										[ngTemplateOutletContext]="{
											$implicit: item.key
										}"></ng-container>
								</div>
								<div class="element-card__count">{{ item.value }}</div>
							</div>
							<div
								class="redirection-to-list"
								(click)="navigateToElementList(item.key)">
								<span i18n="@@project.home.show-all.btn">show all</span>
								<mat-icon
									[svgIcon]="DcIcons.OpenInNewTab"
									matTooltip="show all"
									i18n-matTooltip="@@project.home.show-all.tooltip"></mat-icon>
							</div>
						</div>
					</ng-container>
				</div>
				<div class="project-traces">
					<div class="element-create">
						<button
							*ngIf="vo.canCreate"
							id="{{ cmpId }}'-create-btn"
							class="element-create__btn"
							mat-icon-button
							matTooltip="create new element"
							i18n-matTooltip="@@project.home.create-new.btn"
							matTooltipPosition="before"
							(click)="navigateToCreateElement()">
							<mat-icon [svgIcon]="DcIcons.AddCircle"></mat-icon>
						</button>
					</div>
					<app-panel
						headerHeight="3rem"
						isAlwaysOpen="true"
						hasSearchableGrid="true"
						hasRefresh="true"
						maxActionsCount="6"
						[itemsCount]="vo.traces.elements.size"
						(refresh)="refresh()"
						(search)="search($event)">
						<div panel-title class="panel__title">
							<ng-container
								[ngTemplateOutlet]="elementIcon"
								[ngTemplateOutletContext]="{
									$implicit: vo.selectedElement
								}"></ng-container>
							<span i18n="@@project.home.last-activities-on">
								last activities on
							</span>
							<ng-container
								[ngTemplateOutlet]="elementType"
								[ngTemplateOutletContext]="{
									$implicit: vo.selectedElement
								}"></ng-container>
						</div>
						<dx-data-grid
							keyExpr="id"
							[elementAttr]="{
								id: 'project-trace-list',
								class: 'project-trace-list'
							}"
							[dataSource]="vo.traces.elements | toArray"
							[hoverStateEnabled]="true"
							[showColumnHeaders]="true"
							[allowColumnResizing]="false"
							[columnAutoWidth]="false"
							[showRowLines]="false"
							[showColumnLines]="false"
							[rowAlternationEnabled]="false"
							[showBorders]="false"
							[width]="'100%'">
							<dxo-header-filter [visible]="true"></dxo-header-filter>

							<dxo-load-panel
								shadingColor="rgba(0,0,0,0)"
								[indicatorSrc]="DcLoaders.LoaderInfinite"
								[height]="100"
								[width]="100"
								[enabled]="vo.isFirstLoad"
								[showIndicator]="true"
								[showPane]="true"
								[shading]="true"></dxo-load-panel>

							<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

							<ng-container
								*ngFor="let col of vo.traces.availableColumns | toArray">
								<dxi-column
									*ngIf="col.field === 'action'"
									[dataField]="col.field"
									[dataType]="col.type"
									[format]="col.format"
									[caption]="col.alias"
									[groupIndex]="col.groupIdx"
									[fixed]="false"
									[allowResizing]="true"
									[allowHiding]="true"
									[allowGrouping]="true"
									[allowSearch]="col.isSearchable"
									[allowFiltering]="col.isFilterable"
									[allowSorting]="true"
									[alignment]="'left'"
									[visibleIndex]="col.visibleIndex"
									[filterValue]="col.filterValue"
									[filterValues]="col.filterValues"
									[sortIndex]="col.sortIndex"
									[sortOrder]="col.sortOrder"
									[allowHeaderFiltering]="col.hasHeaderFilter"
									[visible]="col.visible"></dxi-column>
								<dxi-column
									*ngIf="col.field === 'elementLabel'"
									[dataField]="col.field"
									[dataType]="col.type"
									[format]="col.format"
									[caption]="col.alias"
									[groupIndex]="col.groupIdx"
									[fixed]="false"
									[allowResizing]="true"
									[allowHiding]="true"
									[allowGrouping]="true"
									[allowSearch]="col.isSearchable"
									[allowFiltering]="col.isFilterable"
									[allowSorting]="true"
									[alignment]="'left'"
									[visibleIndex]="col.visibleIndex"
									[filterValue]="col.filterValue"
									[filterValues]="col.filterValues"
									[sortIndex]="col.sortIndex"
									[sortOrder]="col.sortOrder"
									[allowHeaderFiltering]="col.hasHeaderFilter"
									[visible]="col.visible"
									cellTemplate="labelTemplate"></dxi-column>
								<dxi-column
									*ngIf="col.field === 'date'"
									[dataField]="col.field"
									[dataType]="col.type"
									[format]="col.format"
									[caption]="col.alias"
									[groupIndex]="col.groupIdx"
									[fixed]="false"
									[allowResizing]="true"
									[allowHiding]="true"
									[allowGrouping]="true"
									[allowSearch]="col.isSearchable"
									[allowFiltering]="col.isFilterable"
									[allowSorting]="true"
									[alignment]="'left'"
									[visibleIndex]="col.visibleIndex"
									[filterValue]="col.filterValue"
									[filterValues]="col.filterValues"
									[sortIndex]="col.sortIndex"
									[sortOrder]="col.sortOrder"
									[width]="col.width ?? 200"
									[allowHeaderFiltering]="col.hasHeaderFilter"
									[visible]="col.visible"
									cellTemplate="dateTemplate"></dxi-column>
								<dxi-column
									*ngIf="col.field === 'modifiedBy'"
									[dataField]="col.field"
									[caption]="col.alias"
									[groupIndex]="col.groupIdx"
									[fixed]="false"
									[allowResizing]="true"
									[allowHiding]="true"
									[allowGrouping]="true"
									[allowSearch]="col.isSearchable"
									[allowFiltering]="col.isFilterable"
									[allowSorting]="false"
									[alignment]="'left'"
									[dataType]="col.type"
									[format]="col.format"
									[visibleIndex]="col.visibleIndex"
									[filterValue]="col.filterValue"
									[filterValues]="col.filterValues"
									[sortIndex]="col.sortIndex"
									[sortOrder]="col.sortOrder"
									[allowHeaderFiltering]="col.hasHeaderFilter"
									cellTemplate="modifiedByAvatarTemplate"></dxi-column>
							</ng-container>

							<div *dxTemplate="let cell of 'labelTemplate'">
								<a appNavigate [navigateTo]="cell.data['elementUrl']">
									{{ cell.data['elementLabel'] }}
								</a>
							</div>

							<div
								*dxTemplate="let cell of 'modifiedByAvatarTemplate'"
								class="avatar-template">
								<app-dc-user
									[dcUserUuid]="cell.data['modifiedBy']"></app-dc-user>
							</div>

							<div *dxTemplate="let cell of 'dateTemplate'">
								<span>
									{{
										cell.data['modificationDate'] | date: 'yyyy-MM-dd HH:mm:ss'
									}}
								</span>
							</div>

							<dxo-group-panel [visible]="true"></dxo-group-panel>

							<!-- Filterable columns	-->
							<dxo-filter-row
								[visible]="vo.traces.elements.size !== 0"></dxo-filter-row>

							<!-- Sorting	-->
							<dxo-sorting mode="multiple"></dxo-sorting>

							<dxo-filter-panel [visible]="true"></dxo-filter-panel>

							<!-- State persistence	-->
							<dxo-state-storing
								type="custom"
								[enabled]="true"
								[savingTimeout]="160"
								[customLoad]="loadState"
								[customSave]="saveState"></dxo-state-storing>
						</dx-data-grid>
					</app-panel>
				</div>
			</div>
			<ng-template #elementIcon let-type>
				<ng-container [ngSwitch]="type">
					<mat-icon
						*ngSwitchCase="DcCoreElementType.CONNECTOR"
						[svgIcon]="GdIcons.Connector"></mat-icon>
					<div *ngSwitchCase="DcCoreElementType.DEPOT">
						<mat-icon [svgIcon]="GdIcons.Depot"></mat-icon>
					</div>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.ENTITY"
						[svgIcon]="GdIcons.Entity"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.DATABLOCK"
						[svgIcon]="GdIcons.DataBlock"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.EXPOSITION"
						[svgIcon]="DcIcons.Share"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.DASHBOARD"
						[svgIcon]="HdIcons.Dashboard"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.CHART"
						[svgIcon]="HdIcons.Chart"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.MAP"
						[svgIcon]="HdIcons.Map"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.GRID"
						[svgIcon]="HdIcons.Grid"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.TIMELINE"
						[svgIcon]="HdIcons.Timeline"></mat-icon>
					<mat-icon
						*ngSwitchCase="DcCoreElementType.MEDIA"
						[svgIcon]="HdIcons.Media"></mat-icon>
				</ng-container>
			</ng-template>
			<ng-template #elementType let-type>
				<ng-container [ngSwitch]="type">
					<span
						*ngSwitchCase="DcCoreElementType.CONNECTOR"
						i18n="@@project.home.stat.connectors">
						connectors
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.DEPOT"
						i18n="@@project.home.stat.depots">
						depots
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.ENTITY"
						i18n="@@project.home.stat.entities">
						entities
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.DATABLOCK"
						i18n="@@project.home.stat.datablocks">
						Databloks
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.EXPOSITION"
						i18n="@@project.home.stat.shares">
						shares
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.DASHBOARD"
						i18n="@@project.home.stat.dashboards">
						dashboards
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.CHART"
						i18n="@@project.home.stat.charts">
						charts
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.MAP"
						i18n="@@project.home.stat.maps">
						maps
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.GRID"
						i18n="@@project.home.stat.grids">
						grids
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.TIMELINE"
						i18n="@@project.home.stat.timelines">
						timelines
					</span>
					<span
						*ngSwitchCase="DcCoreElementType.MEDIA"
						i18n="@@project.home.stat.medias">
						medias
					</span>
				</ng-container>
			</ng-template>
		</app-page-content>
	</app-page>
</ng-container>
